import axios from 'axios';
let baseURL = 'https://yx-api.lvshuhualv.com/';

let authToken;

let isDev = process.env.NODE_ENV === 'development';
if (isDev) {
    // baseURL = 'https://ikuai0.haloom.cc:7991';
    authToken = '1a2e4b95-36e6-4d8c-b343-a41b48ede344';
    localStorage.setItem('authToken', authToken);
}

let ajax = axios.create({
    baseURL,
    withCredentials: true,
});

ajax.interceptors.request.use(function (config) {
    !config.headers.authToken &&
        Object.assign(config.headers, {
            authToken: isDev ? authToken : localStorage.getItem('authToken'),
        });

    return config;
});
ajax.interceptors.response.use(
    function (res) {
        return res.data;
    },
    function (error) {
        return Promise.reject('网络错误');
    }
);

export default ajax;
